import { trustData } from "@/mocks/siteData";

const trustImages = [
  "https://readdy.ai/api/search-image?query=Vibrant%20sneaker%20collection%20on%20light%20sage%20green%20surface%2C%20colorful%20athletic%20shoes%20arranged%20neatly%2C%20bright%20natural%20daylight%2C%20product%20photography%2C%20energetic%20clean%20composition&width=400&height=360&seq=trust-img-01&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Curated%20selection%20of%20folded%20hoodies%20and%20sweaters%20in%20warm%20earth%20tones%20on%20light%20wooden%20surface%2C%20editorial%20photography%2C%20soft%20daylight%2C%20cozy%20minimalist%20composition&width=400&height=360&seq=trust-img-02&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Verified%20badge%20concept%20with%20clothing%20tags%20and%20quality%20labels%20on%20white%20minimalist%20background%2C%20product%20photography%2C%20bright%20studio%20lighting%2C%20trust%20and%20authentication%20theme&width=400&height=360&seq=trust-img-03&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Weekly%20calendar%20with%20fashion%20items%20and%20refresh%20symbol%20on%20light%20blush%20pink%20surface%2C%20conceptual%20photography%2C%20soft%20natural%20light%2C%20update%20and%20freshness%20theme&width=400&height=360&seq=trust-img-04&orientation=landscape",
];

export default function TrustIndicators() {
  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block text-xs font-medium text-foreground-500 tracking-widest uppercase mb-3">
            Trusted by Buyers
          </span>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-900 leading-tight">
            Numbers That{" "}
            <span className="font-heading italic text-accent-500">Speak Trust</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {trustData.map((item, idx) => (
            <div
              key={item.label}
              className="rounded-2xl overflow-hidden bg-white border border-background-200/70 group cursor-default"
            >
              <div className="h-32 md:h-36 relative overflow-hidden">
                <img
                  src={trustImages[idx]}
                  alt={`AcBuy Spreadsheet ${item.label}`}
                  title={`AcBuy Spreadsheet - ${item.label}`}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
              </div>
              <div className="py-5 md:py-6 text-center px-3">
                <span className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-900 block mb-1">
                  {item.value}
                </span>
                <span className="text-xs md:text-sm font-medium text-foreground-600">
                  {item.label}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}